// Generated by scripts/build-ui-icons.mjs.
export { EyeSlash as default } from "../ui/glyphs-3";
